import { Alert } from '@windmill/react-ui';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PreviousStudentPassWarning from 'src/models/PreviousStudentPassWarning';
import { User } from 'src/models/user';
import ShowModal from './StudentWarningSection/ShowModal';

interface PreviousWarningSectionProps {
  student: User;
  warning: PreviousStudentPassWarning;
}

export default function PreviousWarningSection({ student, warning }: PreviousWarningSectionProps) {
  const [showModalOpen, setShowModalOpen] = useState(false);

  return (
    <>
      <Alert type="warning" className="mt-8 relative" data-testid="previous-warning-alert">
        <div className="flex items-center">
          <div className="text-left" style={{ flexGrow: 1 }}>
            <p className="font-semibold">
              <FormattedMessage
                id="previous-period-warning-given"
                values={{
                  period: warning.class.period?.name,
                  subject: `${warning.class.subject?.subjectCode ?? ''} ${warning.class.subject?.name ?? ''}`.trim(),
                  date: warning.submittedAt?.toLocaleDateString(),
                }}
              />
            </p>
            {warning.teacherUser && (
              <p>
                <FormattedMessage id="previous-period-warning-given-by" values={{ teacherName: warning.teacherUser.displayName }} />
              </p>
            )}
          </div>
          <button
            onClick={() => setShowModalOpen(true)}
            className="text-black bg-white py-1 px-3 rounded-full shadow-tableShadow ml-4"
            data-testid="show-previous-warning-button"
          >
            <FormattedMessage id="show-warning" />
          </button>
        </div>
      </Alert>
      <ShowModal
        isOpen={showModalOpen}
        close={() => setShowModalOpen(false)}
        class={warning.class}
        student={student}
        warning={warning}
        supervisor={warning.advisorUser}
        teacher={warning.teacherUser}
      />
    </>
  );
}
